module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar",
    style: (_vm.css)
  }, [(!_vm.gravatarUrl) ? [_vm._v(_vm._s(_vm.initials))] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9650f1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = 580
// module chunks = 1